import { render, staticRenderFns } from "./HomeWhatsHappening.vue?vue&type=template&id=c23ccf28"
import script from "./HomeWhatsHappening.vue?vue&type=script&lang=js"
export * from "./HomeWhatsHappening.vue?vue&type=script&lang=js"
import "./HomeWhatsHappening.vue?vue&type=style&index=0&id=c23ccf28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports